// extracted by mini-css-extract-plugin
export default {"container":"jG-z","header":"kG-z","details":"lG-z","link":"mG-z"};